import React from 'react';
import '../css/ThemeSwitch.css';

export default function ThemeSwitch({ theme, onToggle }) {
  return (
    <button
      className={`theme-switch${theme === 'light' ? ' light' : ' dark'}`}
      aria-label="Téma váltása"
      onClick={onToggle}
      type="button"
    >
      <div className="switch-track">
        {/* Day mode elements */}
        <div className="day-elements">
          <div className="sun" />
          <div className="cloud cloud-1" />
          <div className="cloud cloud-2" />
          <div className="cloud cloud-3" />
        </div>
        
        {/* Night mode elements */}
        <div className="night-elements">
          <div className="moon" />
          <div className="star star-1" />
          <div className="star star-2" />
          <div className="star star-3" />
          <div className="star star-4" />
          <div className="star star-5" />
          <div className="horizon" />
        </div>
      </div>
    </button>
  );
} 